import { Text, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

import { IconProductList } from '../../../NewApplication/Product/components/IconProductList';
import { productCaptions } from '../../../NewApplication/Product/constants';
import { ProductSectionProps } from '../ProductSection';

interface ProductTitleProps extends ProductSectionProps {
  title: string;
}

export const ProductTitle: React.FC<ProductTitleProps> = ({ title, ...rest }) => {
  const productCaption = rest ? productCaptions(rest) : [];

  return (
    <VStack flex={1} space={Spacing['inline.nano']} pb={Spacing['inline.nano']}>
      <Text color={'neutral.black'} fontSize={Typography['fontsize.md']} variant="semibold">
        {title}
      </Text>
      {productCaption?.length > 0 && <IconProductList icons={productCaption} isTooltip />}
    </VStack>
  );
};
